import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.678 9.155C6.382 6.064 9.01 4.498 11.714 4.5c2.704.002 5.331 1.571 6.03 4.663.836 3.69-1.448 6.901-3.646 9.012l-.001.001a3.442 3.442 0 0 1-4.78 0c-2.19-2.111-4.474-5.33-3.639-9.021ZM11.715 3c3.268.002 6.61 1.932 7.493 5.831 1.02 4.51-1.796 8.241-4.07 10.425a4.942 4.942 0 0 1-6.86.001h-.001c-2.266-2.185-5.083-5.923-4.062-10.434.888-3.9 4.232-5.825 7.5-5.823Zm-1.772 7.458a1.769 1.769 0 1 1 3.537 0 1.769 1.769 0 0 1-3.537 0ZM11.71 7.19a3.269 3.269 0 1 0 0 6.538 3.269 3.269 0 0 0 0-6.538Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLocation;
